import { useLayoutEffect, useRef } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import gsap from 'gsap'
import { useInView } from 'react-intersection-observer'
import { createUseStyles } from 'react-jss'
import TextSlide from '@/components/TextSlide'
import ScrollIcon from '@/components/ScrollIcon'
import style from './style'

const useStyles = createUseStyles(style)

const MainHero = ({
  img,
  video,
  pretitle,
  title,
  ctaLabel,
  link,
  ready,
  layout,
  scrollIcon,
  commaTitle,
  backLink,
  parallax,
  bigFont,
  plainFont,
  delay,
  className,
  background,
  color,
}) => {
  const classes = useStyles()
  const $mediaContainer = useRef()
  const [ref, inView] = useInView({ triggerOnce: true, rootMargin: '-40px 0px' })

  useLayoutEffect(() => {
    if (ready) {
      gsap.to($mediaContainer.current, {
        opacity: 1,
        scale: 1,
        duration: 1.2,
        ease: 'expo.out',
        delay: 0.5,
      })
    }
  }, [ready])

  const renderVideo = () => {
    return (
      <video
        className={classes.media}
        autoPlay
        loop
        playsInline
        muted
      >
        <source src={video} />
      </video>
    )
  }

  const renderImage = () => {
    return (
      <img
        className={classes.media}
        src={img}
        alt={title?.join(' ')}
      />
    )
  }

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [classes.layoutCenter]: layout === 'center',
        [classes.layoutBottom]: layout === 'bottom',
        [classes.bigFont]: bigFont,
        [classes.plainFont]: plainFont,
        [classes.backgroundLight]: background === 'light',
        [className]: className,
      })}
      ref={ref}
    >
      <div
        ref={$mediaContainer}
        className={`${classes.mediaContainer} MainHero__mediaContainer`}
      >
        {video !== '' ? renderVideo() : renderImage()}
      </div>
      <div className={classes.content}>
        <TextSlide
          pretitle={pretitle}
          title={title}
          ctaLabel={ctaLabel}
          link={link}
          commaTitle={commaTitle}
          backLink={backLink}
          parallax={parallax}
          inView={inView}
          delay={delay}
          color={color}
        />
      </div>
      {scrollIcon && (
        <div className={classes.scrollIndicator}>
          <ScrollIcon
            show={ready}
            line
          />
        </div>
      )}
    </div>
  )
}

MainHero.propTypes = {
  backLink: PropTypes.bool,
  bigFont: PropTypes.bool,
  plainFont: PropTypes.bool,
  commaTitle: PropTypes.bool,
  img: PropTypes.string.isRequired,
  layout: PropTypes.string,
  parallax: PropTypes.bool,
  pretitle: PropTypes.string,
  scrollIcon: PropTypes.bool,
  title: PropTypes.arrayOf(PropTypes.string).isRequired,
  video: PropTypes.string,
  delay: PropTypes.number,
}

MainHero.defaultProps = {
  backLink: false,
  bigFont: false,
  plainFont: false,
  commaTitle: false,
  layout: 'center',
  parallax: false,
  pretitle: '',
  scrollIcon: false,
  video: '',
  delay: 0,
}

export default MainHero
